/**
 * 토큰 로그인의 `page` — **등록된 라우트일 때만** 그리로 보낸다 (POS 임베드 결정 브리프 2026-09-03 · D3).
 *
 * `page` 는 POS 가 매직링크에 실어 보내는 값인데, 종전에는 `LoginView` 가 검증 없이 `$router.replace` 했다 —
 * 값을 누구나 만들 수 있는 열린 리다이렉트다. 등록 라우트에 매치되는가는 라우터가 답한다(`router.resolve`);
 * 이 함수는 그 답을 주입받아 순수하게 판정하므로 단위 테스트가 라우터 없이 돈다.
 *
 * - 앱 안의 절대 경로(`/…`)만 받는다. 절대 URL(`http://…`)·프로토콜 상대(`//evil`)·역슬래시·상대 경로는 전부 `/`.
 * - `/login` 자체는 목적지가 아니다.
 * - **쿼리스트링은 보존한다** — 임베드 화면은 `?storeCd=` 를 쿼리로 받는다.
 *
 * @param {*} page 쿼리의 `page` 원문
 * @param {(path: string) => boolean} isRegisteredPath 경로(쿼리·해시 제외)가 등록 라우트에 매치되는가
 * @returns {string} 이동할 경로. 검증에 실패하면 `/`
 */
export function safeRedirectPage(page, isRegisteredPath) {
  if (typeof page !== 'string') return '/'
  const target = page.trim()
  if (!target.startsWith('/') || target.startsWith('//') || target.indexOf('\\') > -1) return '/'
  const path = target.split(/[?#]/)[0]
  if (path === '/login') return '/'
  return isRegisteredPath(path) ? target : '/'
}
